<template>
  <edit-form
    delete-btn
    :model="$store.getters['model' + modelName]"
    :rawValues="$store.getters['one' + modelName]"
    @submit="save"
    @delete="del"
    v-if="dataLoaded"
  />
</template>

<script>
import EditForm from "../../components/Form";

export default {
  data: () => ({
    dataLoaded: false
  }),
  components: {
    EditForm
  },
  computed: {
    modelName: function() {
      let name = this.$route.params.model;
      return name.charAt(0).toUpperCase() + name.substring(1);
    }
  },
  mounted() {
    let self = this;
    this.$store.dispatch("loadModel" + this.modelName);
    this.$store.dispatch("findOne" + this.modelName, this.$route.params.id)
    .then(function() {
      self.dataLoaded = true
    });
  },
  methods: {
    save(data) {
      this.$store.dispatch("update" + this.modelName, {
        id: this.$route.params.id,
        data: data
      });
    },
    del() {
      this.$store
        .dispatch("delete" + this.modelName, this.$route.params.id)
        .then(() => {
          this.$router.push({ path: "/model/" + this.$route.params.model });
        });
    }
  }
};
</script>
